import React from 'react';
import { Fade } from '../../animation/animation';
import styles from './button-back.module.scss';
import cn from 'classnames'

interface ButtonBackProps {
	active: boolean
	onClick: (event:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
	mode?: '' | 'division';
}

export default function ButtonBack({onClick, active, mode=''}:ButtonBackProps) {
	return (
		<Fade left duration={400} when={active}>
			<button onClick={onClick} type="button" className={cn(styles.default, styles[mode])}/>
		</Fade>
	);
}